import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, ContainerHeader } from '~components';

import { setTitle } from '~main/actions/login';

const RoreSessionSearch: React.FC = () => {
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    setTitle('RoR.E Sessions');
  }, []);

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    const trimmed = sessionId.trim();
    if (trimmed) {
      navigate(`/rore/sessions/${trimmed}`);
    }
  };

  return (
    <div data-cy="rore-session-search-container">
      <ContainerHeader dataCy="rore-session-search-header">RoR.E Session Viewer</ContainerHeader>
      <div className="p-3">
        <form onSubmit={handleSubmit} data-cy="rore-session-search-form">
          <div className="mb-3">
            <label htmlFor="rore-session-id-input" className="form-label">
              Session ID
            </label>
            <input
              id="rore-session-id-input"
              type="text"
              className="form-control"
              data-cy="rore-session-search-input"
              placeholder="Enter a session ID"
              value={sessionId}
              onChange={(event) => setSessionId(event.target.value)}
            />
          </div>
          <Button
            type="submit"
            color="primary"
            disabled={!sessionId.trim()}
            dataCy="rore-session-search-button"
          >
            View Session
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RoreSessionSearch;
